import * as React from 'react'
import styled from 'styled-components'
import { Article } from '../../../../types'
import moment from '../../../../utilities/Moment'
import { useTranslation } from 'react-i18next'
import Avatar from '../Avatar/Avatar'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  color: rgb(115, 115, 118);
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  padding-bottom: 24px;
  padding-left: 20px;
  padding-right: 20px;

  @media screen and (min-width: 640px) {
    padding-left: 40px;
    padding-right: 40px;
  }
`

const AvatarContainer = styled.div`
  margin-right: 4px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  color: #737373;
  font-weight: 300;
  line-height: 21px;
`

const Author = styled.div`
  font-size: 13px;
`

const Timestamp = styled.div`
  font-size: 13px;

`

interface IProps {
  article: Article
}

const AuthorWithTimestamp = (props: IProps) => {
  const { t } = useTranslation()
  const { article } = props

  return (
    <Container>
      <AvatarContainer>
        <Avatar
          width={32}
          name={article.author?.name || 'TODO:'}
          src={article.author?.avatar_url}
          rounded
        />
      </AvatarContainer>

      <Content>
        <Author>{t('Article::Written by {{author}}', { author: article?.author?.name || 'TODO:' })}</Author>
        <Timestamp>{t('Article::Updated {{timeAgo}}', { timeAgo: moment(article.updated_at).fromNow() })}</Timestamp>
      </Content>
    </Container>
  )
}

export default AuthorWithTimestamp